import { connect } from "react-redux";
import { router } from "store/router";
import { State } from "store";
import { report } from "store/report";
import { profile } from "store/profile";
import { title } from "store/title";
import { project } from "store/project";
import { global } from "store/global";

const mapStateToProps = (state: State) => ({
  currentUser: profile.selectors.User(state),
  carriers: global.selectors.carrierRefs(state),
  currentReport: report.selectors.report(state),
  availableTerritories: project.selectors.territories(state),
});

const mapDispatchToProps = {
  gotoReports: router.goto.report.reportsList,
  fetchReport: report.queries.fetchReport,
  setHeadBar: title.actions.setHeadBar,
  updateCarrierReport: report.commands.updateCarrierReport,
  fetchTerritories: project.queries.fetchUnfinishedTerritories,
};

export default connect(mapStateToProps, mapDispatchToProps);
